var map = {
	"./ic_ai.svg": "yRAU",
	"./ic_chart.svg": "LyFd",
	"./ic_computer.svg": "MxZ1",
	"./ic_copyright.svg": "HYfW",
	"./ic_diamond.svg": "Ar5m",
	"./ic_flexible.svg": "QHQK",
	"./ic_message.svg": "bFdz",
	"./ic_model.svg": "XpY0",
	"./ic_phone.svg": "5wfi",
	"./ic_position.svg": "sxiQ",
	"./ic_secure.svg": "BerL",
	"./ic_top.svg": "yyts",
	"./ic_we_chat.svg": "hobQ",
	"./ic_we_chat2.svg": "ogoe",
	"./云平台.svg": "Mc6H",
	"./区块链.svg": "TvTR",
	"./工业应用开发.svg": "PZyJ",
	"./引擎_分析决策.svg": "ncQT",
	"./数字孪生.svg": "1LtC",
	"./数据清洗.svg": "cbKT",
	"./智能审图.svg": "e+b4",
	"./梯口.svg": "is4G",
	"./特征工程.svg": "+4i9",
	"./生物识别.svg": "RtvV",
	"./电子围栏.svg": "WPcB",
	"./货物行李.svg": "5YJo",
	"./跨部门跨平台.svg": "2JXX",
	"./边缘计算.svg": "0bDm",
	"./锚地.svg": "2J6C",
	"./风险模型.svg": "uaFO",
	"./风险等级.svg": "3C9w",
	"./鹰眼.svg": "y1iw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 15